import { UserSegmentType } from '@/Enums';

export const MARKET_USER_SEGMENTS = [UserSegmentType.MarketUser];
export const BUSINESS_AND_MARKET_USER_SEGMENTS = [UserSegmentType.BusinessUser, UserSegmentType.MarketUser];
